import '../css/GPTApp.css';

function TypingDots({ size = 14, color = '#000', inline = false, ariaLabel = 'Generating answer' }) {
    const dotStyle = { width: size, height: size, background: color };
    return (
        <span className="typing-dots" role="status" aria-label={ariaLabel} style={inline ? { marginLeft: 6 } : {}}>
            <span className="dot" style={dotStyle} />
            <span className="dot" style={dotStyle} />
            <span className="dot" style={dotStyle} />
        </span>
    );
}
export default TypingDots;